<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
// import { useAuthStore } from '@/stores/auth'; // authストアをインポート

const router = useRouter();
const { t } = useI18n();
// const authStore = useAuthStore(); // authストアを使用

const startSinglePlay = () => {
  router.push({ name: 'SinglePlaySelection' });
};

const startMultiplayerGame = () => {
  router.push({ name: 'RoomList' }); // 複数人プレイのルーム一覧ルート名
};
</script>

<template>
  <div class="home-container">
    <h1>{{ t('game.title') }}</h1>
    <p>{{ t('home.select_game_mode') }}</p>
    <div class="game-mode-selection">
      <button @click="startSinglePlay" class="start-button single-play-button">{{ t('home.single_play') }}</button>
      <button @click="startMultiplayerGame" class="start-button multiplayer-button">{{ t('home.multi_play') }}</button>
    </div>

    <div class="description-section">
      <h2>{{ t('home.welcome_title') }}</h2>
      <p>{{ t('home.description') }}</p>
      <p>{{ t('home.score_up') }}</p>
      <p>{{ t('home.single_play_desc') }}</p>
      <p>{{ t('home.multi_play_desc') }}</p>
    </div>
  </div>
</template>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  box-sizing: border-box;
  font-family: 'Arial', sans-serif;
  background-color: #f0f2f5;
  color: #333;
}

h1 {
  font-size: clamp(1rem, 8vw, 3rem);
  color: #2c3e50;
  margin: 0 auto 1rem auto;
  white-space: nowrap;
  width: 100%;
  text-align: center;
  display: block;
}

p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.game-mode-selection {
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.start-button {
  flex: 1;
  min-width: 160px;
  max-width: 250px;
  padding: 1rem 2rem;
  font-size: 1.5rem;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.start-button:hover {
  transform: translateY(-3px);
}

.single-play-button {
  background-color: #17a2b8;
}

.single-play-button:hover {
  background-color: #138496;
}

.multiplayer-button {
  background-color: #6f42c1;
  /* 新しいボタンの色 */
}

.multiplayer-button:hover {
  background-color: #5a35a1;
}

.description-section {
  margin-top: 4rem;
  max-width: 600px;
  text-align: center;
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.description-section h2 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.description-section p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 0.5rem;
}
</style>
